import React, { useState, useEffect } from 'react'
import { ServerConfig } from 'config'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'


import { AppBar, Tabs, Tab, FormControlLabel, Switch, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core'
import _ from 'lodash'

import List from '../../components/EntryListAndEdit/List'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  appBar: {
    background: theme.palette.background.default,
    color: theme.palette.text.primary,
    boxShadow: 'none'
  },
  appBarTitle: {
    flexGrow: 1
  },
}))

const RefundRates = () => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [operationTypes, setOperationTypes] = useState([])
  const [selectedTab, setSelectedTab] = useState(0)
  const [onlyValid, setOnlyValid] = useState(false)
  const [availableStates, setAvailableStates] = useState([])
  const [selectedState, setSelectedState] = useState('all')

  useEffect(() => {
    const fetchOperationTypes = async () => {
      const config = { headers: { 'Content-Type': 'application/json' } }

      if (auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

      const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/machines/operationtypes`, config)
      setOperationTypes(results.data)
    }

    fetchOperationTypes();
  }, [])

  const editable_fields = [
    //["id", "ID", "str"],
    ["state", "State", "str"],
    ["operationtype_id", "Operation Type", "operationtype"],
    ["validity_start", "Validity Start", "date"],
    ["validity_end", "Validity End", "date"],
    ["material", "Material", "material"],
    ["microdollar_per_pound", "µ$/lbs", "microdollar"],
    ["daily_weight_limit_lbs", "Limit lbs/day", "int"],
  ];

  const isCurrentlyValid = (entry) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (entry.validity_start && new Date(entry.validity_start) > today) {
      return false;
    }
    if (entry.validity_end && new Date(entry.validity_end) < today) {
      return false;
    }
    return true;
  };

  // selectedTab === 0 is the "All" tab, tabs after that map 1:1 to operationTypes
  const selectedOperationType = selectedTab === 0 ? null : operationTypes[selectedTab - 1];

  const handleEntriesLoaded = (loadedEntries) => {
    setAvailableStates(_.sortBy(_.uniq(_.map(loadedEntries, 'state').filter(Boolean))));
  };

  const filterFn = (entry) => {
    if (selectedOperationType && entry.operationtype_name !== selectedOperationType.name) {
      return false;
    }
    if (selectedState !== 'all' && entry.state !== selectedState) {
      return false;
    }
    if (onlyValid && !isCurrentlyValid(entry)) {
      return false;
    }
    return true;
  };

  const toolbar = (
    <>
      <AppBar className={classes.appBar} position="static" >
        <Tabs
          value={selectedTab}
          onChange={(event, newValue) => setSelectedTab(newValue)}
          variant="scrollable"
          indicatorColor="primary"
          //textColor="primary"
        >
          <Tab label="All" />
          {operationTypes.map(opt => <Tab key={opt.id} label={opt.name} />)}
        </Tabs>
      </AppBar>

      <FormControl style={{ minWidth: 160, margin: '10px' }}>
        <InputLabel id="refundrates-state-filter-label">State</InputLabel>
        <Select
          labelId="refundrates-state-filter-label"
          value={selectedState}
          onChange={(event) => setSelectedState(event.target.value)}
        >
          <MenuItem value="all">All</MenuItem>
          {availableStates.map(state => <MenuItem key={state} value={state}>{state}</MenuItem>)}
        </Select>
      </FormControl>

      <FormControlLabel
        control={
          <Switch
            checked={onlyValid}
            onChange={(event) => setOnlyValid(event.target.checked)}
            color="primary"
          />
        }
        label="Only show currently valid rates"
      />
    </>
  );

  return (
    <>
      <List
        list_get_url={`${ServerConfig.SERVER_URL}/admin/refundrates`}
        detail_get_url={`${ServerConfig.SERVER_URL}/admin/refundrates/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/admin/refundrates/`}
        add_new_url={`${ServerConfig.SERVER_URL}/admin/refundrates`}

        column_names={["id", "state", "operationtype_name", "validity_start", "validity_end", "material", "dollar_per_pound", "daily_weight_limit_lbs", "edit"]}
        header_names={["ID", "state", "OP type", "Valid from", "Valid until", "Material", "$/lbs", "Limit lbs/day", ""]}

        editable_fields={editable_fields}
        toolbar={toolbar}
        filterFn={filterFn}
        onEntriesLoaded={handleEntriesLoaded}
      />
    </>
  )
}

export default RefundRates